import{a as i}from"./chunk-KI6CRLFQ.js";import{m as e}from"./chunk-HBP5N4FR.js";e();function T(n){return i(n)}export{T as a};
//# sourceMappingURL=chunk-YQO3KEQ3.js.map
